import { useSelector } from 'react-redux';
import { Buttons, FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import StorageService from 'Services/storage';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { useGetSatUserQuery } from 'Containers/Datagathering/components/QuizLoaderBanner/hooks';
import { routes } from 'Constants/routes';
import { stages } from 'Constants/stages';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import * as Styled from './styles';
import { ImageByResult } from './utils';

const STORAGE_KEY = 'quiz_correct_answers';

const QuizResult = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const data = useGetSatUserQuery();
  const isPreviousYears = useSelector(routeStateSelector);
  const correctsAnswers = Number(StorageService.getItem(STORAGE_KEY) || 0);
  const downloadData =
    data?.stage?.value &&
    [stages.DATA_PARTIAL_PULLED, stages.DATA_PULLED].includes(data?.stage?.value);

  const handleClick = (): void => {
    const nextRoute =
      downloadData && !isPreviousYears?.products?.isPreviousYear
        ? routes.PERSONAL_START
        : routes.DATAGATHERING_LOADER;
    history.push(nextRoute, {
      products: isPreviousYears?.products ?? {},
    });
  };

  const resultAsNumber = correctsAnswers > 5 ? 5 : correctsAnswers;
  return (
    <Styled.QuizResultContainer direction="column" align="center" fullWidth justify="space-between">
      <Styled.QuizResultContent
        direction="column"
        fullWidth
        align="center"
        justify="center"
        gap="dimension_24"
      >
        <FlexContainer direction="column" fullWidth align="center" gap="dimension_08">
          <Text type="paragraphs" size="XL_L_S" color="dark">
            {t('Quiz.result.title', {
              context: resultAsNumber,
            })}
          </Text>
          <Text type="paragraphs" size="XS_M_S" color="grey">
            {t('Quiz.result.subtitle')}
          </Text>
          <Styled.CorrectsAnswers
            align="center"
            gap="dimension_04"
            $correctAnswers={resultAsNumber}
          >
            {resultAsNumber === 0 ? (
              <Icon icon="StarM" color="default" />
            ) : (
              <img src={`${TAXDOWN_ASSETS_DOMAIN}/icons/svg/general/star_solid.svg`} alt="star" />
            )}
            <Text type="paragraphs" size="M_L_M" color={resultAsNumber === 0 ? 'dark' : 'fresh'}>
              {t('Quiz.result.correct.answers', {
                answers: resultAsNumber,
              })}
            </Text>
          </Styled.CorrectsAnswers>
        </FlexContainer>
        <FlexContainer direction="column" fullWidth align="center" gap="dimension_08">
          <Text type="paragraphs" size="XS_S_S" color="dark">
            {t('Quiz.result.nivel')}
          </Text>
          <img src={ImageByResult[resultAsNumber]} alt="ajolote" />
          <Text type="paragraphs" size="L_L_S" color="dark">
            {t('Quiz.result.nivel.description', {
              context: resultAsNumber,
            })}
          </Text>
        </FlexContainer>
        <Styled.ExtraInfo
          alignContent="flex-start"
          alignItems="flex-start"
          columns="auto auto"
          gap="dimension_04"
        >
          <img src={`${TAXDOWN_ASSETS_DOMAIN}/icons/svg/general/icon.svg`} alt="star" />
          <Text type="paragraphs" size="S_M_M" color="dark">
            {t('Quiz.result.correct.answers', {
              context: resultAsNumber,
            })}
          </Text>
        </Styled.ExtraInfo>
      </Styled.QuizResultContent>
      <Styled.ButtonContainer fullWidth align="center" justify="center">
        <Buttons.Classic
          label={t('Quiz.result.continue.button')}
          onClick={handleClick}
          mode="primary"
          size="m"
        />
      </Styled.ButtonContainer>
    </Styled.QuizResultContainer>
  );
};

export default QuizResult;
